import React from 'react';

// --- Internal CSS for all styling ---
const internalCSS = `
  /* --- Main Page Container --- */
  .about-trainer-container {
    background-color: #fff; /* White background */
    font-family: 'Poppins', sans-serif; /* Default sans-serif */
    padding: 3rem 1rem;
    color: #333; /* Default text color */
  }

  /* --- Title Section --- */
  .trainer-title-section {
    text-align: center;
    margin-bottom: 2rem;
  }

  .trainer-main-title {
    font-family: 'Times New Roman', Times, serif; /* Serif font for title */
    font-size: 2.8rem;
    font-weight: 700;
    color: #212529; /* Dark color */
    margin-bottom: 0.5rem;
  }

  /* --- Image Sections --- */
  .image-section {
    position: relative; /* For overlay positioning */
    margin-bottom: 2rem;
    border-radius: 8px; /* Slight rounding */
    overflow: hidden;
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
  }

  .trainer-image {
    display: block; /* Remove extra space below image */
    width: 100%;
    height: auto;
  }

  .image-overlay-text {
    position: absolute;
    bottom: 10px;
    left: 50%;
    transform: translateX(-50%);
    background-color: rgba(0, 0, 0, 0.7); /* Dark semi-transparent background */
    color: #fff;
    padding: 0.5rem 1rem;
    border-radius: 6px;
    font-size: 0.85rem;
    font-weight: 600;
    text-align: center;
    width: 90%; /* Adjust width as needed */
    white-space: normal; /* Allow text wrapping */
    line-height: 1.4;
  }
  
  /* Specific styling for the second overlay (yellow text) */
  .overlay-yellow-text {
     color: #ffd700; /* Yellow */
     font-size: 0.9rem;
     font-weight: 700;
     margin-bottom: 0.25rem;
     display: block; /* Ensure it takes its own line */
  }

  /* --- Text Description Section --- */
  .trainer-description {
    font-size: 1rem;
    line-height: 1.7;
    color: #444; /* Slightly lighter text */
  }
  
  .trainer-description strong {
     color: #212529; /* Darker bold text */
     font-weight: 700;
  }

  /* --- Responsive Adjustments --- */
  @media (max-width: 767.98px) { /* Mobile Devices */
     .about-trainer-container {
        padding: 2rem 0.75rem;
     }
     .trainer-main-title {
       font-size: 2.2rem;
     }
     .image-overlay-text {
        font-size: 0.75rem;
        padding: 0.4rem 0.8rem;
     }
     .overlay-yellow-text {
        font-size: 0.8rem;
     }
     .trainer-description {
       font-size: 0.95rem;
       line-height: 1.6;
     }
  }
`;

const AboutTrainer = () => {
  return (
    <>
      <style>{internalCSS}</style>
      
      <div className="about-trainer-container">
        <div className="container"> {/* Use Bootstrap container for centering */}
          
          {/* --- 1. Title Section --- */}
          <div className="trainer-title-section">
            <h1 className="trainer-main-title">About Trainer</h1>
          </div>
          
          {/* --- 2. First Image with Overlay --- */}
          <div className="image-section">
            <img 
              src="https://skillsuprise.com/resources/images/g7.png" 
              alt="Trainer receiving award" 
              className="trainer-image"
            />
            <div className="image-overlay-text">
              <span className="overlay-yellow-text">Best Educational Service Provider Award</span>
              Awarded by Former Governor of Chhattisgarh at Global Business & Education Awards - 2023
            </div>
          </div>
          
          {/* --- 3. Second Image with Overlay --- */}
          <div className="image-section">
            <img 
              src="https://skillsuprise.com/resources/images/g8.png" 
              alt="Trainer with Police Officers" 
              className="trainer-image"
            />
            <div className="image-overlay-text">
              <span className="overlay-yellow-text">Trained DSP Officers of Andhra Pradesh</span>
              on Ethical Hacking & Cyber Security
            </div>
          </div>
          
          {/* --- 4. Text Description Section --- */}
          <div className="trainer-description">
            Manoj Kumar Koravangi is the <strong>Founder and CEO of Awetecks & SkillsUprise</strong>. He's a leading corporate trainer helping students, individuals and corporate teams to build successful careers by training them over 20+technologies with <strong>4+ years experience (as of 2023)</strong> in <strong>successfully leading 25+ software development teams</strong> and training 5000+ individuals with <strong>4.8/5 average rating</strong>.
          </div>
          
        </div>
      </div>
    </>
  );
};

export default AboutTrainer;